import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import classNames from "classnames";
import lh from "helpers/linkHandler";
import { stylesheetsAPI, requests } from "api";
import { entityStoreActions } from "actions";
import IconComposer from "global/components/utility/IconComposer";

import Stylesheet from "backend/components/stylesheet";
import withConfirmation from "hoc/withConfirmation";

const { request } = entityStoreActions;

export class TextStylesContainer extends PureComponent {
  static displayName = "Text.Styles";

  static propTypes = {
    text: PropTypes.object,
    dispatch: PropTypes.func,
    refresh: PropTypes.func,
    confirm: PropTypes.func.isRequired,
    t: PropTypes.func
  };

  static defaultProps = {
    confirm: (heading, message, callback) => callback()
  };

  get text() {
    return this.props.text;
  }

  get stylesheets() {
    return this.text.relationships.stylesheets;
  }

  get callbacks() {
    return {
      updatePosition: this.updatePosition,
      confirmDestroy: this.confirmDestroy
    };
  }

  get buttonClasses() {
    return classNames(
      "buttons-icon-horizontal__button",
      "button-icon-secondary"
    );
  }

  confirmDestroy = stylesheet => {
    const t = this.props.t;
    const heading = t("backend_entities.stylesheets.modals.confirm_heading");
    const message = t("backend_entities.stylesheets.modals.confirm_body");
    this.props.confirm(heading, message, () => this.destroy(stylesheet));
  };

  destroy = stylesheet => {
    const call = stylesheetsAPI.destroy(stylesheet.id);
    const options = { removes: stylesheet };
    const stylesheetRequest = request(
      call,
      requests.beStylesheetDestroy,
      options
    );
    this.props.dispatch(stylesheetRequest).promise.then(() => {
      this.props.refresh();
    });
  };

  updatePosition = (stylesheet, newPos) => {
    const changes = {
      attributes: { position: newPos }
    };
    const call = stylesheetsAPI.update(stylesheet.id, changes);
    const options = { notificationScope: "none" };
    const stylesheetRequest = request(
      call,
      requests.beStylesheetUpdate,
      options
    );
    this.props.dispatch(stylesheetRequest).promise.then(() => {
      this.props.refresh();
    });
  };

  render() {
    const t = this.props.t;
    return (
      <div>
        <section className="text-category-list-secondary">
          <div className="instructional-copy">
            <p>{t("backend_entities.stylesheets.instructions")}</p>
          </div>

          <div className="buttons-icon-horizontal maintain">
            <Link
              className={this.buttonClasses}
              to={lh.link("BackendTextStylesheetNew", this.text.id)}
            >
              <IconComposer
                icon="plus16"
                size={18}
                className={classNames(
                  "button-icon-secondary__icon",
                  "button-icon-secondary__icon--large"
                )}
              />
              <span>{t("backend_entities.stylesheets.add_button_label")}</span>
            </Link>
          </div>

          <Stylesheet.List
            stylesheets={this.stylesheets}
            text={this.text}
            callbacks={this.callbacks}
          />
        </section>
      </div>
    );
  }
}

export default withTranslation()(withConfirmation(TextStylesContainer));
